import AccessRequestModal from './AccessRequestModal';

export default AccessRequestModal;
